
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const transformOrganizations = (data) => {
  const myData = Object.values(Object.assign({}, data))[0];
  const filtered = {};
  const items = [];

  for (let x in myData) {
    filtered[x] = myData[x];
  }

  const cleaned = Object.assign({}, filtered);

  const org_object = {
    id: cleaned.id,
    key: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
    value: cleaned.name,
    name: cleaned.name,
    address_1: cleaned.address_1,
    address_2: cleaned.address_2,
    city: cleaned.city,
    region: cleaned.region,
    site_limit: cleaned.site_limit,
    country_code: cleaned.country_code,
    postal_code: cleaned.postal_code,
    type: 'org',
    disabled: true,
    collection: 0,
    isEditing: false,
    isParent: true,
  };

  items.push(Object.assign({}, org_object));

  if (cleaned.sites) {
    Object.values(cleaned.sites).forEach((item) => {
      items.push({
        ...item,
        site: item.id,
        value: item.name,
        type: 'site',
        disabled: true,
        collection: items.length === 1 ? 0 : 1,
        isEditing: false,
        isParent: item.departments ? true : false,
      });
      if (item.departments) {
        for (let [key, value] of Object.entries(item.departments)) {
          items.push({
            id: key,
            site: item.id,
            value: value,
            disabled: false,
            type: 'dept',
            collection: 1,
            isEditing: false,
            isParent: false,
          });
        }
      }
    });
  }

  return {
    items: items,
  }
}

export const states = [
  { name: 'Alabama', abbrev: 'AL' },
  { name: 'Alaska', abbrev: 'AK' },
  { name: 'Arizona', abbrev: 'AZ' },
  { name: 'Arkansas', abbrev: 'AR' },
  { name: 'California', abbrev: 'CA' },
  { name: 'Colorado', abbrev: 'CO' },
  { name: 'Connecticut', abbrev: 'CT' },
  { name: 'Delaware', abbrev: 'DE' },
  { name: 'Florida', abbrev: 'FL' },
  { name: 'Georgia', abbrev: 'GA' },
  { name: 'Hawaii', abbrev: 'HI' },
  { name: 'Idaho', abbrev: 'ID' },
  { name: 'Illinois', abbrev: 'IL' },
  { name: 'Indiana', abbrev: 'IN' },
  { name: 'Iowa', abbrev: 'IA' },
  { name: 'Kansas', abbrev: 'KS' },
  { name: 'Kentucky', abbrev: 'KY' },
  { name: 'Louisiana', abbrev: 'LA' },
  { name: 'Maine', abbrev: 'ME' },
  { name: 'Maryland', abbrev: 'MD' },
  { name: 'Massachusetts', abbrev: 'MA' },
  { name: 'Michigan', abbrev: 'MI' },
  { name: 'Minnesota', abbrev: 'MN' },
  { name: 'Mississippi', abbrev: 'MS' },
  { name: 'Missouri', abbrev: 'MO' },
  { name: 'Montana', abbrev: 'MT' },
  { name: 'Nebraska', abbrev: 'NE' },
  { name: 'Nevada', abbrev: 'NV' },
  { name: 'New Hampshire', abbrev: 'NH' },
  { name: 'New Jersey', abbrev: 'NJ' },
  { name: 'New Mexico', abbrev: 'NM' },
  { name: 'New York', abbrev: 'NY' },
  { name: 'North Carolina', abbrev: 'NC' },
  { name: 'North Dakota', abbrev: 'ND' },
  { name: 'Ohio', abbrev: 'OH' },
  { name: 'Oklahoma', abbrev: 'OK' },
  { name: 'Oregon', abbrev: 'OR' },
  { name: 'Pennsylvania', abbrev: 'PA' },
  { name: 'Rhode Island', abbrev: 'RI' },
  { name: 'South Carolina', abbrev: 'SC' },
  { name: 'South Dakota', abbrev: 'SD' },
  { name: 'Tennessee', abbrev: 'TN' },
  { name: 'Texas', abbrev: 'TX' },
  { name: 'Utah', abbrev: 'UT' },
  { name: 'Vermont', abbrev: 'VT' },
  { name: 'Virginia', abbrev: 'VA' },
  { name: 'Washington', abbrev: 'WA' },
  { name: 'West Virginia', abbrev: 'WV' },
  { name: 'Wisconsin', abbrev: 'WI' },
  { name: 'Wyoming', abbrev: 'WY' }
];

export const country_list = [
  { id: "1",
    name: "Afghanistan"
  },
  { id: "2",
    name: "Aland Islands"
  },
  { id: "3",
    name: "Albania"
  },
  { id: "4",
    name: "Algeria"
  },
  { id: "5",
    name: "American Samoa"
  },
  { id: "6",
    name: "Andorra"
  },
  { id: "7",
    name: "Angola"
  },
  { id: "8",
    name: "Anguilla"
  },
  { id: "9",
    name: "Antarctica"
  },
  { id: "10",
    name: "Antigua and Barbuda"
  },
  { id: "11",
    name: "Argentina"
  },
  { id: "12",
    name: "Armenia"
  },
  { id: "13",
    name: "Aruba"
  },
  { id: "14",
    name: "Australia"
  },
  { id: "15",
    name: "Austria"
  },
  { id: "16",
    name: "Azerbaijan"
  },
  { id: "17",
    name: "Bahamas"
  },
  { id: "18",
    name: "Bahrain"
  },
  { id: "19",
    name: "Bangladesh"
  },
  { id: "20",
    name: "Barbados"
  },
  { id: "21",
    name: "Belarus"
  },
  { id: "22",
    name: "Belgium"
  },
  { id: "23",
    name: "Belize"
  },
  { id: "24",
    name: "Benin"
  },
  { id: "25",
    name: "Bermuda"
  },
  { id: "26",
    name: "Bhutan"
  },
  { id: "27",
    name: "Bolivia"
  },
  { id: "28",
    name: "Bosnia and Herzegovina"
  },
  { id: "29",
    name: "Botswana"
  },
  { id: "30",
    name: "Bouvet Island"
  },
  { id: "31",
    name: "Brazil"
  },
  { id: "32",
    name: "British Virgin Islands"
  },
  { id: "33",
    name: "British Indian Ocean Territory"
  },
  { id: "34",
    name: "Brunei Darussalam"
  },
  { id: "35",
    name: "Bulgaria"
  },
  { id: "36",
    name: "Burkina Faso"
  },
  { id: "37",
    name: "Burundi"
  },
  { id: "38",
    name: "Cambodia"
  },
  { id: "39",
    name: "Cameroon"
  },
  { id: "40",
    name: "Canada"
  },
  { id: "41",
    name: "Cape Verde"
  },
  { id: "42",
    name: "Cayman Islands"
  },
  { id: "43",
    name: "Central African Republic"
  },
  { id: "44",
    name: "Chad"
  },
  { id: "45",
    name: "Chile"
  },
  { id: "46",
    name: "China"
  },
  { id: "47",
    name: "Hong Kong, SAR China"
  },
  { id: "48",
    name: "Macao, SAR China"
  },
  { id: "49",
    name: "Christmas Island"
  },
  { id: "50",
    name: "Cocos(Keeling) Islands"
  },
  { id: "51",
    name: "Colombia"
  },
  { id: "52",
    name: "Comoros"
  },
  { id: "53",
    name: "Congo(Brazzaville) "
  },
  { id: "54",
    name: "Congo, (Kinshasa) "
  },
  { id: "55",
    name: "Cook Islands"
  },
  { id: "56",
    name: "Costa Rica"
  },
  { id: "57",
    name: "C\u00f4te d’Ivoire"
  },
  { id: "58",
    name: "Croatia"
  },
  { id: "59",
    name: "Cuba"
  },
  { id: "60",
    name: "Cyprus"
  },
  { id: "61",
    name: "Czech Republic"
  },
  { id: "62",
    name: "Denmark"
  },
  { id: "63",
    name: "Djibouti"
  },
  { id: "64",
    name: "Dominica"
  },
  { id: "65",
    name: "Dominican Republic"
  },
  { id: "66",
    name: "Ecuador"
  },
  { id: "67",
    name: "Egypt"
  },
  { id: "68",
    name: "El Salvador"
  },
  { id: "69",
    name: "Equatorial Guinea"
  },
  { id: "70",
    name: "Eritrea"
  },
  { id: "71",
    name: "Estonia"
  },
  { id: "72",
    name: "Ethiopia"
  },
  { id: "73",
    name: "Falkland Islands(Malvinas) "
  },
  { id: "74",
    name: "Faroe Islands"
  },
  { id: "75",
    name: "Fiji"
  },
  { id: "76",
    name: "Finland"
  },
  { id: "77",
    name: "France"
  },
  { id: "78",
    name: "French Guiana"
  },
  { id: "79",
    name: "French Polynesia"
  },
  { id: "80",
    name: "French Southern Territories"
  },
  { id: "81",
    name: "Gabon"
  },
  { id: "82",
    name: "Gambia"
  },
  { id: "83",
    name: "Georgia"
  },
  { id: "84",
    name: "Germany"
  },
  { id: "85",
    name: "Ghana"
  },
  { id: "86",
    name: "Gibraltar"
  },
  { id: "87",
    name: "Greece"
  },
  { id: "88",
    name: "Greenland"
  },
  { id: "89",
    name: "Grenada"
  },
  { id: "90",
    name: "Guadeloupe"
  },
  { id: "91",
    name: "Guam"
  },
  { id: "92",
    name: "Guatemala"
  },
  { id: "93",
    name: "Guernsey"
  },
  { id: "94",
    name: "Guinea"
  },
  { id: "95",
    name: "Guinea - Bissau"
  },
  { id: "96",
    name: "Guyana"
  },
  { id: "97",
    name: "Haiti"
  },
  { id: "98",
    name: "Heard and Mcdonald Islands"
  },
  { id: "99",
    name: "Holy See(Vatican City State) "
  },
  { id: "100",
    name: "Honduras"
  },
  { id: "101",
    name: "Hungary"
  },
  { id: "102",
    name: "Iceland"
  },
  { id: "103",
    name: "India"
  },
  { id: "104",
    name: "Indonesia"
  },
  { id: "105",
    name: "Iran, Islamic Republic of"
  },
  { id: "106",
    name: "Iraq"
  },
  { id: "107",
    name: "Ireland"
  },
  { id: "108",
    name: "Isle of Man"
  },
  { id: "109",
    name: "Israel"
  },
  { id: "110",
    name: "Italy"
  },
  { id: "111",
    name: "Jamaica"
  },
  { id: "112",
    name: "Japan"
  },
  { id: "113",
    name: "Jersey"
  },
  { id: "114",
    name: "Jordan"
  },
  { id: "115",
    name: "Kazakhstan"
  },
  { id: "116",
    name: "Kenya"
  },
  { id: "117",
    name: "Kiribati"
  },
  { id: "118",
    name: "Korea(North) "
  },
  { id: "119",
    name: "Korea(South) "
  },
  { id: "120",
    name: "Kuwait"
  },
  { id: "121",
    name: "Kyrgyzstan"
  },
  { id: "122",
    name: "Lao PDR"
  },
  { id: "123",
    name: "Latvia"
  },
  { id: "124",
    name: "Lebanon"
  },
  { id: "125",
    name: "Lesotho"
  },
  { id: "126",
    name: "Liberia"
  },
  { id: "127",
    name: "Libya"
  },
  { id: "128",
    name: "Liechtenstein"
  },
  { id: "129",
    name: "Lithuania"
  },
  { id: "130",
    name: "Luxembourg"
  },
  { id: "131",
    name: "Macedonia, Republic of"
  },
  { id: "132",
    name: "Madagascar"
  },
  { id: "133",
    name: "Malawi"
  },
  { id: "134",
    name: "Malaysia"
  },
  { id: "135",
    name: "Maldives"
  },
  { id: "136",
    name: "Mali"
  },
  { id: "137",
    name: "Malta"
  },
  { id: "138",
    name: "Marshall Islands"
  },
  { id: "139",
    name: "Martinique"
  },
  { id: "140",
    name: "Mauritania"
  },
  { id: "141",
    name: "Mauritius"
  },
  { id: "142",
    name: "Mayotte"
  },
  { id: "143",
    name: "Mexico"
  },
  { id: "144",
    name: "Micronesia, Federated States of"
  },
  { id: "145",
    name: "Moldova"
  },
  { id: "146",
    name: "Monaco"
  },
  { id: "147",
    name: "Mongolia"
  },
  { id: "148",
    name: "Montenegro"
  },
  { id: "149",
    name: "Montserrat"
  },
  { id: "150",
    name: "Morocco"
  },
  { id: "151",
    name: "Mozambique"
  },
  { id: "152",
    name: "Myanmar"
  },
  { id: "153",
    name: "Namibia"
  },
  { id: "154",
    name: "Nauru"
  },
  { id: "155",
    name: "Nepal"
  },
  { id: "156",
    name: "Netherlands"
  },
  { id: "157",
    name: "Netherlands Antilles"
  },
  { id: "158",
    name: "New Caledonia"
  },
  { id: "159",
    name: "New Zealand"
  },
  { id: "160",
    name: "Nicaragua"
  },
  { id: "161",
    name: "Niger"
  },
  { id: "162",
    name: "Nigeria"
  },
  { id: "163",
    name: "Niue"
  },
  { id: "164",
    name: "Norfolk Island"
  },
  { id: "165",
    name: "Northern Mariana Islands"
  },
  { id: "166",
    name: "Norway"
  },
  { id: "167",
    name: "Oman"
  },
  { id: "168",
    name: "Pakistan"
  },
  { id: "169",
    name: "Palau"
  },
  { id: "170",
    name: "Palestinian Territory"
  },
  { id: "171",
    name: "Panama"
  },
  { id: "172",
    name: "Papua New Guinea"
  },
  { id: "173",
    name: "Paraguay"
  },
  { id: "174",
    name: "Peru"
  },
  { id: "175",
    name: "Philippines"
  },
  { id: "176",
    name: "Pitcairn"
  },
  { id: "177",
    name: "Poland"
  },
  { id: "178",
    name: "Portugal"
  },
  { id: "179",
    name: "Puerto Rico"
  },
  { id: "180",
    name: "Qatar"
  },
  { id: "181",
    name: "R\u00e9union"
  },
  { id: "182",
    name: "Romania"
  },
  { id: "183",
    name: "Russian Federation"
  },
  { id: "184",
    name: "Rwanda"
  },
  { id: "185",
    name: "Saint - Barth\u00e9lemy"
  },
  { id: "186",
    name: "Saint Helena"
  },
  { id: "187",
    name: "Saint Kitts and Nevis"
  },
  { id: "188",
    name: "Saint Lucia"
  },
  { id: "189",
    name: "Saint - Martin(French part) "
  },
  { id: "190",
    name: "Saint Pierre and Miquelon"
  },
  { id: "191",
    name: "Saint Vincent and Grenadines"
  },
  { id: "192",
    name: "Samoa"
  },
  { id: "193",
    name: "San Marino"
  },
  { id: "194",
    name: "Sao Tome and Principe"
  },
  { id: "195",
    name: "Saudi Arabia"
  },
  { id: "196",
    name: "Senegal"
  },
  { id: "197",
    name: "Serbia"
  },
  { id: "198",
    name: "Seychelles"
  },
  { id: "199",
    name: "Sierra Leone"
  },
  { id: "200",
    name: "Singapore"
  },
  { id: "201",
    name: "Slovakia"
  },
  { id: "202",
    name: "Slovenia"
  },
  { id: "203",
    name: "Solomon Islands"
  },
  { id: "204",
    name: "Somalia"
  },
  { id: "205",
    name: "South Africa"
  },
  { id: "206",
    name: "South Georgia and the South Sandwich Islands"
  },
  { id: "207",
    name: "South Sudan"
  },
  { id: "208",
    name: "Spain"
  },
  { id: "209",
    name: "Sri Lanka"
  },
  { id: "210",
    name: "Sudan"
  },
  { id: "211",
    name: "Suriname"
  },
  { id: "212",
    name: "Svalbard and Jan Mayen Islands"
  },
  { id: "213",
    name: "Swaziland"
  },
  { id: "214",
    name: "Sweden"
  },
  { id: "215",
    name: "Switzerland"
  },
  { id: "216",
    name: "Syrian Arab Republic(Syria) "
  },
  { id: "217",
    name: "Taiwan, Republic of China"
  },
  { id: "218",
    name: "Tajikistan"
  },
  { id: "219",
    name: "Tanzania, United Republic of"
  },
  { id: "220",
    name: "Thailand"
  },
  { id: "221",
    name: "Timor - Leste"
  },
  { id: "222",
    name: "Togo"
  },
  { id: "223",
    name: "Tokelau"
  },
  { id: "224",
    name: "Tonga"
  },
  { id: "225",
    name: "Trinidad and Tobago"
  },
  { id: "226",
    name: "Tunisia"
  },
  { id: "227",
    name: "Turkey"
  },
  { id: "228",
    name: "Turkmenistan"
  },
  { id: "229",
    name: "Turks and Caicos Islands"
  },
  { id: "230",
    name: "Tuvalu"
  },
  { id: "231",
    name: "Uganda"
  },
  { id: "232",
    name: "Ukraine"
  },
  { id: "233",
    name: "United Arab Emirates"
  },
  { id: "234",
    name: "United Kingdom"
  },
  { id: "235",
    name: "United States of America"
  },
  { id: "236",
    name: "US Minor Outlying Islands"
  },
  { id: "237",
    name: "Uruguay"
  },
  { id: "238",
    name: "Uzbekistan"
  },
  { id: "239",
    name: "Vanuatu"
  },
  { id: "240",
    name: "Venezuela(Bolivarian Republic) "
  },
  { id: "241",
    name: "Viet Nam"
  },
  { id: "242",
    name: "Virgin Islands, US"
  },
  { id: "243",
    name: "Wallis and Futuna Islands"
  },
  { id: "244",
    name: "Western Sahara"
  },
  { id: "245",
    name: "Yemen"
  },
  { id: "246",
    name: "Zambia"
  },
  { id: "247",
    name: "Zimbabwe"
  },
];
